import { Component, Inject, OnInit, ViewContainerRef } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { AppService } from '../../../../app.service';
import { JobsiteSelectionFilter } from '../../favourite-dialog/favourite-dialog-modal';
import { FavouriteDialogService } from '../../favourite-dialog/favourite-dialog.service';
import { CustomerSelectItem } from '../../setup-equipment/setup-equipment.model';
import { GETSetupEquipmentService } from '../../setup-equipment/setup-equipment.service';
import { GenericIdName } from '../../setup-implement/setup-implement.model';
import { ImplementRebuildService } from '../fecr-implement-rebuild-details/implement-rebuild.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-move-implement-to-repairer',
  templateUrl: './move-implement-to-repairer.component.html',
  styleUrls: ['./move-implement-to-repairer.component.scss']
})
export class MoveImplementToRepairerComponent implements OnInit {
  customerList: CustomerSelectItem[] = [];
  jobsiteList: GenericIdName[] = [];
  selectedCustomer: number;
 selectedJobsite: number; 
 selectedCustomerList:number[]=[];

  implementId:number;
  impName:string;
  repairerList:GenericIdName[]=[];
  repairerId:number;
  workshopList:GenericIdName[]=[];
  workshopId:number;
  savingChanges:boolean=false;

  isReturn:boolean=false;
  constructor(private _appService: AppService, public dialogRef: MatDialogRef<MoveImplementToRepairerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private _moduleService: ImplementRebuildService, 
     private _favouriteDialogService:FavouriteDialogService,private _equipmentService: GETSetupEquipmentService,
    public toastr: NotificationsService, vcr: ViewContainerRef) {

}

  ngOnInit() {
    this.isReturn=this.data.isReturn;
    this.impName = this.data.implementName;
    this.implementId = this.data.implementId;
    this.LoadAllRepairerList();
    this.loadCustomers();
    
  }

  loadCustomers() {
    this._equipmentService.getCustomerList().subscribe(r => {
        this.customerList = r;
        this.selectedCustomer = this.data. InventoryCustomerId;
        if( this.selectedCustomer>0){
          this.loadJobsitesForCustomer();
        }
       
      
    });
}
loadJobsitesForCustomer() {
  if (this.selectedCustomer == null)
      return;
  this.selectedJobsite = null;
  this.jobsiteList = null;
  let arr = [];
  arr.push(this.selectedCustomer);
  this.selectedCustomerList = arr;
  var params: JobsiteSelectionFilter = {
      Customers: this.selectedCustomerList,
    }
  this._favouriteDialogService.GetjobsitesAvailable(params).subscribe(r => {
      if (r) {
          this.jobsiteList = r;
          this.selectedJobsite = this.data.InventoryJobsiteId;
      }
    });
}
  LoadAllRepairerList(){
      this._moduleService.getRepairerList().subscribe(res=>{
        console.log("Repairer  list ", res)
        this.repairerList=res;
      })
  }

  LoadWorkShopLits(){
    this._moduleService.getWorkshopList(this.repairerId).subscribe(res=>{
      console.log("workshop", res)
      this.workshopList=res;
    })
  }

  repairerSelected(){
    this.LoadWorkShopLits();
  }


  onCloseClick(): void {
    this.dialogRef.close();
}
  MoveImplementToRepairer(){
    this.savingChanges=true;
    console.log("data",this.repairerId,this.workshopId, this.implementId)
    this._moduleService.MoveImplementToRepairer(this.repairerId,this.workshopId, this.implementId).subscribe(res=>{
      
      if(res.m_Item1==true){
        this.toastr.success(res.m_Item2);
        this.savingChanges=false;
        this.dialogRef.close();
      }else{
        this.toastr.error(res.m_Item2);
        this.savingChanges=false;
      }
    })
  }

  ReturntoTheInventory(){
    
    if(this.selectedJobsite!=null && this.selectedJobsite>0){
      this.savingChanges=true;
      this._moduleService.ReturnImplementToFromRepairerInventory(this.implementId,this.selectedJobsite).subscribe(res=>{
        if(res.m_Item1==true){
          this.toastr.success(res.m_Item2);
          this.savingChanges=false;
          this.dialogRef.close();
        }else{
          this.toastr.error(res.m_Item2);
          this.savingChanges=false;
        }
      })
    }
    else{

    }
    
  }
}
